import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "header-container"
};
const _hoisted_2 = {
  class: "main-box"
};
const _hoisted_3 = {
  class: "image-slot"
};
const _hoisted_4 = {
  style: {
    "margin": "0 auto"
  }
};
import { Picture as IconPicture } from '@element-plus/icons-vue';
import NavMenu from './NavMenu'; // 组件-导航栏菜单
import { useRouter } from 'vue-router';
export default /*@__PURE__*/Object.assign({
  name: 'Header'
}, {
  __name: 'index',
  props: {
    logo: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const router = useRouter();
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h1", {
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/')),
        title: "首页",
        class: "animate__animated animate__rubberBand"
      }, [_createVNode(_component_el_image, {
        src: __props.logo,
        alt: "logo",
        class: "img-format"
      }, {
        error: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(IconPicture))]),
          _: 1
        })])]),
        _: 1
      }, 8, ["src"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_unref(NavMenu))])])]);
    };
  }
});